"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GET_PARENTAL_SETTINGS_QUERY = "\n  query GetParentalSettings {\n    user {\n      parentalSettings {\n        parentalControl\n        approvedClassification\n        pinValidationStatus {\n          attempts\n          timeoutEnd\n        } \n      }\n    }\n  }\n  ";
exports.default = GET_PARENTAL_SETTINGS_QUERY;
//# sourceMappingURL=getParentalSettings.js.map